<div fxFlex id="dashboard">

    <!-- <div class="title">ANNOUNCEMENTS</div>
  <mat-card class="upper-mat-card">
    <mat-card-title>FitForce Server Downtime: 10/18/2019 from 0900 to 1100 EST</mat-card-title>
    <mat-card-content>
      <ul>
        <li>
          <b>Please ensure that any unsaved changes to plans have been synced before the time above.</b>
        </li>
        <li>
          In order to deploy the next feature update, <em>FitForce Planner</em> and <em>Mobile</em>
          will be unavailable during this time to facilitate a database migration.
        </li>
        <li>
          We apologize for the interruption, and thank you for your patience during this transition.
        </li>
      </ul>
    </mat-card-content>
  </mat-card> -->

    <div class="container dashboard-container">
        <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="16px">
            <mat-card fxFlex="33%" id="planning-card">
                <img mat-card-image src="assets\images\planning.png">
                <mat-card-title>Planning</mat-card-title>
                <mat-card-content>
                    Create and manage monthly training plans at the unit level.
                </mat-card-content>
                <mat-card-actions>
                    <button mat-button (click)="createPlan()">VIEW</button>
                </mat-card-actions>
            </mat-card>
            <mat-card fxFlex="33%" id="group-management-card">
                <img mat-card-image src="assets\images\injuries.png">
                <mat-card-title>Group Management</mat-card-title>
                <mat-card-content>
                    Create new groups and add Marines to them.
                </mat-card-content>
                <mat-card-actions>
                    <button mat-button (click)="viewManagement()" [disabled]="!isOnline">VIEW</button>
                </mat-card-actions>
            </mat-card>
            <mat-card fxFlex="33%" id="explore-card">
                <img mat-card-image src="assets\images\trends.png">
                <mat-card-title>Explore</mat-card-title>
                <mat-card-content>
                    Analyze unit performance over time.
                </mat-card-content>
                <mat-card-actions>
                    <button mat-button (click)="viewTrends()" [disabled]="!isOnline">VIEW</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>

    <app-feedback id="feedback-section" [disabled]="isOnline"></app-feedback>
</div>
<ngx-guided-tour></ngx-guided-tour>